export const environment = {
  production: false,
  name: 'qa',
  api_url: 'https://qa-one2.kordata.mx/',
  graphql_url: 'https://qa-one2.kordata.mx/graphql',
  front_url: 'https://qa2.kordata.mx/',
  stripe_pk: 'pk_test_51Sf6PkIZhmsUoQn7Q7rNMD0VP8ATI3T91fPXnGgiw6mI4Pzz6Vszc9rBg6CS8bwuDqCrX7wdBe9tbUOFsgu8BGYu006e6Pracg',
};
